const crud = { c: false, r: false, u: false, d: false };

export const datasets = Object.freeze({
  dataset: { ...crud },
  previewDataset: { ...crud },
});
